function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import { StepContent as MuiStepContent, Collapse } from '@material-ui/core';

var styles = {
    root: {}
};

/**
 * A component that displays progress through numbered steps.
 */
var StepContent = React.forwardRef(function (props, ref) {
    var classes = props.classes,
        rest = _objectWithoutProperties(props, ['classes']);

    var classOverrides = {
        root: classes.root
    };

    return React.createElement(MuiStepContent, Object.assign({}, rest, {
        classes: classOverrides,
        ref: ref
    }));
});

StepContent.muiName = 'StepContent';
StepContent.displayName = 'StepContent';

StepContent.propTypes = {
    /**
     * Step content.
     */
    children: PropTypes.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * Collapse component.
     */
    TransitionComponent: PropTypes.elementType,
    /**
     * Adjust the duration of the content expand transition.
     * Passed as a property to the transition component.
     *
     * Set to 'auto' to automatically calculate transition time based on height.
     */
    transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({ enter: PropTypes.number, exit: PropTypes.number }), PropTypes.oneOf(['auto'])]),
    /**
     * Properties applied to the `Transition` element.
     */
    TransitionProps: PropTypes.object
};

StepContent.defaultProps = {
    TransitionComponent: Collapse,
    transitionDuration: 'auto'
};

export default withStyles(styles)(StepContent);